import React from "react";
import PropTypes from "prop-types";
import "./BookingSearch.scss";
import SearchEngineContainer from "app/pages/PrePackage/containers/SearchEngineContainer";
import { FormattedMessage } from "react-intl";
import RentalSearchEngineContainer from "app/pages/PrePackage/rental/RentalSearchEngineContainer";
import AlertMessage from "app/pages/.shared/AlertMessage";
import Loader from "app/pages/.shared/Loader";

const BookingSearch = ({ isRental, alertMessage, displaySearchEngine }) => {
	return (
		<div className="booking-search">
			{alertMessage && <AlertMessage message={alertMessage} />}
			<header className="booking-search__title">
				<FormattedMessage id="search.booking.title" />
			</header>
			{/* displaySearchEngine permet d'afficher le moteur de recherche que si on a l'info ficheProduit.isChildAgeRequired
			ce qui permet d'afficher les champs dates de naissances ou pas en fonction
			*/}
			{displaySearchEngine ? (
				<div className="booking-search__content">
					{isRental ? <RentalSearchEngineContainer /> : <SearchEngineContainer />}
				</div>
			) : (
				<div className="booking-search__content" style={{ textAlign: "center" }}>
					<Loader />
				</div>
			)}
		</div>
	);
};

BookingSearch.propTypes = {
	displaySearchEngine: PropTypes.bool,
	isRental: PropTypes.bool,
	alertMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default React.memo(BookingSearch);
